import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import s from './mobileFilters.scss';
import Modal from '../Modal';
import { ICONS } from '../../constants';
import Button from '../Clickable';
import Accordion from '../Accordion';
import List from '../List';
import Checkbox from '../Checkbox';
import { filtersMessages as messages } from '../../defineMessages';
import Label from '../Label';
import { toggleMobileMenu } from '../../actions/header';
import { clearFilters } from '../../actions/shop';

const MobileFilters = ({
  isVisible,
  filters,
  onFilterChange,
  intl,
  dispatch,
  products,
}) => {
  const filterElements = filters.map(filter => {
    if (filter.type === 'filter') {
      const filterKey = filter.key;
      const filterItems = filter.items;
      const filterItemKeys = Object.keys(filterItems);
      const selectedCount = Object.keys(filterItems).reduce(
        (acc, filterItemKey) =>
          filterItems[filterItemKey].checked ? acc + 1 : acc,
        0,
      );
      const Title = () => (
        <List container component="div">
          <List item grow>
            {intl.formatMessage({ ...messages[filterKey] })}
          </List>
          {selectedCount > 0 && (
            <List item>
              <Label
                bold
                size="caption"
              >{`(${selectedCount} ${intl.formatMessage({
                ...messages.selected,
              })})`}</Label>
            </List>
          )}
        </List>
      );
      return {
        key: filterKey,
        title: <Title />,
        body: (
          <List container direction="column" spacing={16}>
            {filterItemKeys.map(filterItemKey => {
              const filterItem = filterItems[filterItemKey];
              return (
                <List item component="li" key={filterItemKey}>
                  <Checkbox
                    alternative
                    name={filterItemKey}
                    label={filterItem.label}
                    showLabel
                    checked={filterItem.checked}
                    onChange={({ target: { checked } }) =>
                      onFilterChange(filterItemKey, checked, filterKey)
                    }
                  />
                </List>
              );
            })}
          </List>
        ),
      };
    }
    if (filter.type === 'priceInterval') {
      return <></>;
    }
    throw new Error(`Invalid filter ${filter.toString()}`);
  });

  return (
    <Modal
      isVisible={isVisible}
      fullScreen
      divider
      animation="slideUp"
      title={intl.formatMessage({ ...messages.filters })}
      triggerProps={{
        basic: true,
        fluid: true,
        rtl: true,
        label: intl.formatMessage({ ...messages.filters }),
        icon: { name: ICONS.FILTERS },
        className: 'filters-btn',
      }}
      headerAction={
        <Button
          naked
          label={intl.formatMessage({ ...messages.reset })}
          className={s.edit}
          onClick={() => dispatch(clearFilters())}
        />
      }
      footer={
        <Button
          primary
          fluid
          label={intl.formatMessage({ ...messages.showResults })}
          onClick={() => dispatch(toggleMobileMenu('filters'))}
        />
      }
      handleClick={() => dispatch(toggleMobileMenu('filters'))}
    >
      <Accordion
        style={{ borderBottom: '1px solid #dfe3e8' }}
        items={filterElements}
        products={products}
      />
    </Modal>
  );
};

MobileFilters.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['filter', 'priceInterval']),
      items: PropTypes.shape(), // Not required for type priceInterval
    }).isRequired,
  ).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  intl: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

const mapState = state => ({
  isVisible: state.header.filters,
  products: state.shop.data,
});

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState),
)(MobileFilters);
